import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/ic_windows-fill.png'


const _withScopeId = n => (_pushScopeId("data-v-9c84d6cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "download-btn absolute" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "marginRight4"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  name: "downloadErp",
  style: {"display":"none"}
}, null, -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "show-code"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "qr" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "large" }, "授权码", -1))
const _hoisted_13 = { class: "large" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请勿泄露您的授权码，如果您授权码存在疑问，请联系我们的客服 ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "授权码有效期10分钟，过期需重新授权， ", -1))
const _hoisted_18 = { class: "num" }
const _hoisted_19 = { class: "home-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_BannerView = _resolveComponent("BannerView")!
  const _component_CoreFunc = _resolveComponent("CoreFunc")!
  const _component_FivePoint = _resolveComponent("FivePoint")!
  const _component_PlayWell = _resolveComponent("PlayWell")!
  const _component_CompareErp = _resolveComponent("CompareErp")!
  const _component_BluePrint = _resolveComponent("BluePrint")!
  const _component_Cooperate = _resolveComponent("Cooperate")!
  const _component_HotLine = _resolveComponent("HotLine")!
  const _component_FooterView = _resolveComponent("FooterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BannerView, { imgBg: _ctx.imgBg }, {
      extraOpt: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            class: "inline-flex flex-center orange",
            onClick: _ctx.downloadErp
          }, {
            icon: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Windows版下载 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_4
        ])
      ]),
      _: 1
    }, 8, ["imgBg"]),
    _createElementVNode("div", {
      class: "helper",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.jumpHelper && _ctx.jumpHelper(...args)))
    }, [
      _createElementVNode("img", { src: _ctx.helpBg }, null, 8, _hoisted_5)
    ]),
    (_ctx.code)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("img", { src: _ctx.ele_get_invitation_code }, null, 8, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: _ctx.ele_home_code,
              alt: ""
            }, null, 8, _hoisted_9),
            _createElementVNode("img", {
              src: _ctx.qrcode,
              alt: "",
              class: "qrcode"
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.codeHide()) + " ", 1),
              (!_ctx.onShow)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.btn_password_hide_h,
                    alt: "",
                    class: "password-hide",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onShow = true))
                  }, null, 8, _hoisted_14))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.btn_password_show_h,
                    alt: "",
                    class: "password-hide show",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onShow = false))
                  }, null, 8, _hoisted_15)),
              _createElementVNode("span", {
                class: "btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
              }, "复制")
            ]),
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("div", null, [
              _createTextVNode("有效期倒计时："),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getDate()), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_CoreFunc),
      _createVNode(_component_FivePoint),
      _createVNode(_component_PlayWell),
      _createVNode(_component_CompareErp),
      _createVNode(_component_BluePrint),
      _createVNode(_component_Cooperate),
      _createVNode(_component_HotLine)
    ]),
    _createVNode(_component_FooterView)
  ]))
}